import { createSelector } from 'redux-starter-kit';

export default {
  isMenuOpen: createSelector(['ui.isMenuOpen']),
};
